'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupRoute = undefined;

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _products = require('features/Products/products');

var _Products = require('features/Products/Products.helpers');

var _SignupOnenter = require('features/Signup/Signup.onenter.saga');

var _runOnEnter = require('routes/helpers/runOnEnter');

var _runOnEnter2 = _interopRequireDefault(_runOnEnter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

var SignupRoute = exports.SignupRoute = function SignupRoute(store, client) {
  return {
    path: 'signup',

    onEnter: function onEnter(_ref, replaceState) {
      var location = _ref.location;

      if (/\/signup\/?$/.test(location.pathname)) {
        replaceState('/');
      }
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      var bounceToPurchaseIfLoggedIn = function bounceToPurchaseIfLoggedIn(nextState, replaceState, cb) {
        return store.runSagaOnce(_SignupOnenter.signupOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
      };

      var cartAbandonerOnEnter = function cartAbandonerOnEnter(nextState, replaceState, cb) {
        return store.runSagaOnce(_SignupOnenter.cartAbandonerOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
      };

      require.ensure([], function (require) {
        var _require = require('./SignupContainer'),
            SignupContainer = _require.SignupContainer;

        callback(null, [{
          path: 'continue',
          component: require('./CartAbandoner').CartAbandoner,
          onEnter: cartAbandonerOnEnter
        }, {
          path: 'live/:encodedPlanId/:encodedLivePlanId',
          component: SignupContainer,
          onEnter: (0, _runOnEnter2.default)(bounceToPurchaseIfLoggedIn, (0, _Products.activateProductOnEnter)(store, _products.LiveProduct, function (params) {
            return {
              planId: _Base2.default.decodeNumber(params.encodedPlanId),
              livePlanId: _Base2.default.decodeNumber(params.encodedLivePlanId)
            };
          }))
        }, {
          path: 'offer/:encodedMsaOfferId',
          component: SignupContainer,
          onEnter: (0, _runOnEnter2.default)(bounceToPurchaseIfLoggedIn, (0, _Products.activateProductOnEnter)(store, _products.MsaOfferProduct, function (params) {
            return {
              msaOfferId: _Base2.default.decodeNumber(params.encodedMsaOfferId)
            };
          }))
        }, {
          path: 'plan/:encodedPlanId',
          component: SignupContainer,
          onEnter: (0, _runOnEnter2.default)(bounceToPurchaseIfLoggedIn, (0, _Products.activateProductOnEnter)(store, _products.PlanProduct, function (params) {
            return {
              planId: _Base2.default.decodeNumber(params.encodedPlanId)
            };
          }))
        }]);
      }, 'Signup');
    }
  };
};